import type Konva from 'konva';

/**
 * Rendert die sichtbare Stage (= Zuschnitt) in Originalaufloesung als PNG-Blob.
 *
 * Die Stage ist zur Anzeige mit `scale` skaliert; `pixelRatio = 1 / scale`
 * kompensiert das, sodass das Ergebnis pixelgenau der Originalgroesse entspricht.
 * UI-Elemente (Transformer, Griffe) liegen in `uiLayer` und werden ausgeblendet.
 */
export const exportStageToPngBlob = async (
  stage: Konva.Stage,
  uiLayer: Konva.Layer | null,
  scale: number,
): Promise<Blob> => {
  const wasVisible = uiLayer?.isVisible() ?? false;
  if (uiLayer) uiLayer.hide();
  try {
    const canvas = stage.toCanvas({ pixelRatio: 1 / scale });
    return await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (blob) resolve(blob);
        else reject(new Error('PNG-Export fehlgeschlagen'));
      }, 'image/png');
    });
  } finally {
    if (uiLayer && wasVisible) uiLayer.show();
  }
};

/** Laedt ein Bild aus einem Blob (same-origin Object-URL → Canvas bleibt exportierbar). */
export const loadImageFromBlob = (blob: Blob): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Bild konnte nicht geladen werden'));
    };
    img.src = url;
  });
